// extracted by mini-css-extract-plugin
export default {"emote":"_-2LrY"};